import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson22: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson21"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">
            Nutrition Workout
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson23"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-gainsboro-100 font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>Post Workout Meal</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                After a hard workout, your body is in need of nutrients to help
                it recover and rebuild muscle. A post-workout meal is a great
                way to provide your body with the nutrients it needs to repair
                and strengthen your muscles.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                A post-workout meal should be high in protein and carbohydrates.
                Protein is essential for muscle repair and growth, while
                carbohydrates provide your body with energy. A good post-workout
                meal should also include fruits and vegetables, which are packed
                with vitamins, minerals, and antioxidants.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                There are a few different things you can eat for a post-workout
                meal. Some popular options include:
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`A protein shake: `}</b>
            <span>
              A protein shake is a great option for a post-workout meal because
              it is quick and easy to make, and it is a good source of protein
              and carbohydrates. You can make your own protein shake at home, or
              you can buy a pre-made protein shake.
            </span>
          </div>
          <img
            className="relative w-[34.63rem] h-[20.81rem] object-cover"
            alt=""
            src="/42@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>A bowl of oatmeal with fruit:</b>
            <span>
              {" "}
              Oatmeal is a good source of carbohydrates and fiber, and it is
              also a good source of protein if you add some nuts or seeds to it.
              Top your oatmeal with some fruit for a nutrient-rich post-workout
              meal.
            </span>
          </div>
          <img
            className="relative w-[34.63rem] h-[29.38rem] object-cover"
            alt=""
            src="/44@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`A turkey sandwich on whole-wheat bread: `}</b>
            <span>
              A turkey sandwich on whole-wheat bread is a good source of protein
              and carbohydrates. Choose lean turkey and whole-wheat bread to
              make this a healthy post-workout meal.
            </span>
          </div>
          <img
            className="relative w-[34.63rem] h-[25.94rem] object-cover"
            alt=""
            src="/45@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`A grilled chicken breast with vegetables: `}</b>
            <span>
              Grilled chicken breast is a good source of protein, and vegetables
              are a good source of vitamins, minerals, and fiber. This is a
              healthy and satisfying post-workout meal.
            </span>
          </div>
          <img
            className="relative w-[34.63rem] h-[23.06rem] object-cover"
            alt=""
            src="/46@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`A banana with peanut butter: `}</b>
            <span>
              A banana with peanut butter is a good source of carbohydrates,
              protein, and fiber. This is a quick and easy post-workout snack
              that will help you recover from your workout.
            </span>
          </div>
          <img
            className="relative w-[34.63rem] h-[26.94rem] object-cover"
            alt=""
            src="/47@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify">
          <p className="m-0">
            <span>
              <span>
                It is important to eat your post-workout meal within 30 minutes
                of finishing your workout. This will help your body to absorb
                the nutrients and start the recovery process.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If you are short on time, you can also have a quick post-workout
                snack. Some good options for post-workout snacks include:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>A handful of nuts</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>A piece of fruit</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>A yogurt</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>A hard-boiled egg</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Here are some additional tips for eating a post-workout meal:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-orangered-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-[1.88rem] text-white">
            <b>
              <span>Choose foods that are easy to digest.</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                After a workout, your body is already working hard to recover.
                Eating foods that are easy to digest will help your body absorb
                the nutrients it needs more easily.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-[1.88rem] text-white">
            <b>
              <span>Avoid foods that are high in fat or sugar.</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Fat and sugar can slow down your body's ability to absorb
                nutrients. Instead, choose foods that are low in fat and sugar.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-[1.88rem] text-white">
            <b>
              <span>Drink plenty of water.</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Water is essential for good health, and it is especially
                important after a workout. Drinking plenty of water will help
                your body stay hydrated and recover from your workout.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-[1.88rem] text-white">
            <b>
              <span>
                The Importance of Taking Whey Protein After Working Out
              </span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Whey protein is a type of protein that is quickly absorbed by
                the body. This makes it an ideal protein to consume after a
                workout, when your body is most in need of nutrients.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Whey protein can help to improve muscle recovery and growth. It
                can also help to reduce muscle soreness.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If you are looking to improve your muscle mass and strength,
                then whey protein is a great supplement to consider.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-[1.88rem] text-white">
            <b>
              <span>The Protein Synthesis Process</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Protein synthesis is the process by which your body builds new
                proteins. This process is essential for muscle growth and
                repair.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                There are a few things that can affect protein synthesis,
                including:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>The amount of protein you consume</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>The quality of the protein you consume</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>The timing of your protein intake</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                After a workout, your body is more sensitive to protein. This
                means that you can get more benefits from consuming protein
                after a workout.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If you are looking to improve your muscle growth and repair,
                then it is important to consume protein after a workout.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Here are some tips for maximizing protein synthesis after a
                workout:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Consume 20-25 grams of protein within 30 minutes of finishing
                  your workout.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Choose a high-quality protein source, such as whey protein.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Combine your protein with carbohydrates, such as fruit or a
                  whole-grain carbohydrate source.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                By following these tips, you can help to maximize protein
                synthesis and improve your muscle growth and repair.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>Common Post-Workout Meal Mistakes</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Here are some common post-workout meal mistakes to avoid:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">{`Not eating anything at all. `}</b>
                <span>
                  This is one of the biggest mistakes people make. After a hard
                  workout, your body is in need of nutrients to help it recover
                  and rebuild muscle. If you don't eat anything after your
                  workout, your body will start to break down muscle for energy.
                  This can lead to muscle loss and fatigue.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Eating too much.</b>
                <span>
                  {" "}
                  It's important to eat after a workout, but it's also important
                  not to eat too much. Eating too much after a workout can lead
                  to weight gain.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">{`Eating unhealthy foods. `}</b>
                <span>
                  It's important to eat healthy foods after a workout. Eating
                  unhealthy foods can sabotage your fitness goals.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Not drinking enough water.</b>
                <span>
                  {" "}
                  It's important to stay hydrated, especially after a workout.
                  Drinking plenty of water will help your body recover from your
                  workout.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Here are some tips for avoiding common post-workout meal
                  mistakes:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">
                  Plan your post-workout meal ahead of time
                </b>
                <span>
                  . This will help you avoid making unhealthy choices.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">{`Eat a balanced meal. `}</b>
                <span>
                  Your post-workout meal should include protein, carbohydrates,
                  and healthy fats.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Listen to your body.</b>
                <span> If you're not hungry, don't force yourself to eat.</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Drink plenty of water.</b>
                <span>
                  {" "}
                  Water is essential for good health, and it's especially
                  important after a workout.
                </span>
              </span>
            </span>
          </p>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson23"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson22;
